import { ErrorBoundary } from '@sentry/react'
import { BankPortalContext } from 'bank-portal-context'
import { ConfirmationProvider } from 'ui/components/Dialog/ConfirmationDialogV2'
import { ToastContainer, ToastGlobalStyle } from 'ui/components/Toast'

import { useMainPage } from './hooks'
import { AppRoutes } from './routes'

export const MainPage = () => {
  const {
    activateZendeskWidget,
    barMinimized,
    changeBarMinimized,
    layout,
    isOnlyApplicationsAndAccountSettingsAccessible,
    customSidebarItems,
    setCustomSidebarItems,
    showConnectionsSectionMenu
  } = useMainPage()

  return (
    <ErrorBoundary showDialog>
      <BankPortalContext.Provider
        value={{
          activateZendeskWidget,
          barMinimized,
          changeBarMinimized,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          layout,
          isOnlyApplicationsAndAccountSettingsAccessible,
          customSidebarItems,
          setCustomSidebarItems
        }}
      >
        <ConfirmationProvider>
          <AppRoutes accessibleRoutes={layout?.routerItems} showConnectionsSectionMenu={showConnectionsSectionMenu} />
        </ConfirmationProvider>
      </BankPortalContext.Provider>
      <ToastContainer />
      <ToastGlobalStyle />
    </ErrorBoundary>
  )
}
